import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import style from '../style/pages/Profile.module.scss';
import ProfileEmails from '../containers/ProfileEmails';
import Preferences from '../containers/ProfilePreferences';
import ProfilesWrapper from '../components/profile/ProfilesWrapper';
import WalletProfile from './WalletProfile';
import { trackPageView } from '../utils/analytics';

const Profile = ({ location = {}, history = {} }) => {
  const inlineEmailEdit = useSelector(
    (state) => state.featureFlags.inlineEmailEdit,
  );

  useEffect(() => {
    if (!inlineEmailEdit) {
      // WalletProfile does its own tracking, so only track page view here if inlineEmailEdit is false
      trackPageView();
    }
  }, [inlineEmailEdit]);

  if (inlineEmailEdit) {
    return <WalletProfile location={location} history={history} />;
  }

  return (
    <main className={style.content}>
      <ProfilesWrapper />
      <ProfileEmails />
      <Preferences />
    </main>
  );
};

export default Profile;
